import React, { useEffect, useState } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { MdFileDownload } from "react-icons/md";
import { useLocation } from "react-router-dom";

ChartJS.register(ArcElement, Tooltip, Legend);


function AdminReports(props) {
  const [tickets, setTickets] = useState([]);
  const [detailTicket, setDetailTicket] = useState(null);
  const [showTicket, setShowTicket] = useState(false);
const [filterDate, setFilterDate] = useState("");
const [filterToDate, setFilterToDate] = useState("");

const [filterStatus, setFilterStatus] = useState("");
const[product,setProduct] = useState([]);
  const [companies, setCompanies] = useState([]);
    const location = useLocation();

    const initialCompanyId = location.state?.companyId || "";
const [selectedCompanyId, setSelectedCompanyId] = useState(initialCompanyId);


  useEffect(() => {
    const getTicketsData = async () => {
      try {
        if (props.clientDetails) {
          const response = await axios.get(
            `https://api.dectwinservices.com/api/tickets/${props.clientDetails.id}`
          );
          setTickets(response.data);
             
          localStorage.setItem("tickets", JSON.stringify(response.data));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/tickets"
          );
          setTickets(response.data);
          localStorage.setItem("tickets", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };

        const getCompanies = async () => {
      try {
        const storedCompany = localStorage.getItem("companies");

        if (storedCompany) {
          setCompanies(JSON.parse(storedCompany));
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/companies"
          );
          setCompanies(response.data);
          localStorage.setItem("companies", JSON.stringify(response.data));
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };

    getCompanies();
    getTicketsData();
  }, [props]);


  
useEffect(() => {
  const prodId = props.clientDetails?.item_id;

  if (!prodId) return;


  getProduct(prodId);

}, [props.clientDetails?.prod_id]);


 const getProduct = async (prodId) => {

  if (!prodId) return;

  try {
    const response = await axios.get(
      `https://api.dectwinservices.com/api/products-by-id/${prodId}`
    );

    setProduct(response.data)
  } catch (e) {
    console.log("API error:", e.response?.data || e.message);
  }
};


    const handleShowDetail = (tkt) => {
setDetailTicket(tkt);
setShowTicket(true);
}

    const exportToExcel = () => {
      if (!tickets || tickets.length === 0) {
        console.error("No data to export.");
        return;
      }
  
      // Define the columns for the Excel file
      const formattedData = tickets.map((item) => ({
        "Title/Issue": `${props.clientDetails == null ? `${item.assigned_company_id}-` : `${props.clientDetails.company_id}-`}${item.ticket_inv}${item.ticket_inv}`,
        "Category": item.category,
        "Sub Category": item.sub_category,
        "Description": item.description,
        "Impact": item.impact_level,
        "Priority": item.urgency,
        "Create Date": item.create_date,
        'Solve Date': item.solve_date,
        "Status": item.status,
        "Resolve Note": item.resolve_notes || 'NA',
      }));
  
      // Create a new worksheet
      const ws = XLSX.utils.json_to_sheet(formattedData);
  
      // Create a new workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Tickets");
  
      // Convert workbook to a binary Excel file
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  
      // Create a Blob and trigger download
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, `Reports.xlsx`);
    };


    const statusCount = tickets.reduce((acc, curr) => {
    acc[curr.status] = (acc[curr.status] || 0) + 1;
    return acc;
  }, {});

  const pieData = {
    labels: Object.keys(statusCount),
    datasets: [
      {
        data: Object.values(statusCount),
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#00C49F", "#9966FF"],
        hoverOffset: 10,
      },
    ],
  };


  const filteredTickets = tickets.filter((tkt) => {
     const matchCompany =
      !selectedCompanyId ||
      String(tkt.assign_comp) === String(selectedCompanyId);

  // const matchDate =
  //   !filterDate ||
  //   new Date(tkt.create_date).toISOString().slice(0, 10) === filterDate;
    const ticketDate = new Date(tkt.create_date);

  const fromDate = filterDate ? new Date(filterDate) : null;
  const toDate = filterToDate ? new Date(filterToDate) : null;

  if (fromDate) {
    fromDate.setHours(0, 0, 0, 0);
  }

  if (toDate) {
    toDate.setHours(23, 59, 59, 999);
  }

  const matchDate =
    (!fromDate || ticketDate >= fromDate) &&
    (!toDate || ticketDate <= toDate);

  const matchStatus =
    !filterStatus || tkt.status.toLowerCase() === filterStatus.toLowerCase();
  return matchDate && matchStatus && matchCompany;
});


  function removeSeconds(dateTime) {
  return dateTime.slice(0, 16);
}
  return (
    <section className="px-32">
       <div className="d-md-flex justify-between">
        <div className="d-flex">
          <i className="bx bxs-receipt" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big mb-2">&nbsp;View Reports</p>
        </div>

         <div className="d-md-flex d-sm-flex">
<div className="my-2 px-1">
 <input
      type="date"
      value={filterDate}
      onChange={(e) => setFilterDate(e.target.value)}
      className="form-control"
      title="From Date"
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
      }}
    />
    </div>
<div className="my-2 px-1">
  <input
    type="date"
    value={filterToDate}
    onChange={(e) => setFilterToDate(e.target.value)}
    className="form-control"
    title="To Date"
    min={filterDate || undefined}
    style={{
      padding: "8px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
    }}
  />
</div>

    {/* 📋 Status Dropdown */}
<div className="my-2 px-1">    <select
      value={filterStatus}
      onChange={(e) => setFilterStatus(e.target.value)}
      className="form-control"
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
      }}
    >
      <option value="">All Status</option>
      <option value="Open">Open</option>
      <option value="Closed">Closed</option>
    </select>
    </div>
  {props.clientDetails == null &&
      <div className="my-2 px-1">
            <select
      style={{
        // padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
      }}
              className="form-control"
              value={selectedCompanyId}
              onChange={(e) => setSelectedCompanyId(e.target.value)}
            >
              <option value="">All Companies</option>
              {companies.map((comp) => (
                <option key={comp.id} value={comp.id}>
                  {comp.company_name}
                </option>
              ))}
            </select>
</div>
}

<div className="my-2 px-1">
                  <button
            className="add-btn "
            style={{ background: "#00AA00" }}
            onClick={exportToExcel}
          ><MdFileDownload size={20} />
           
            Excel
          </button>
</div>
      </div>          </div>


            <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
          <thead className="p-3 bg-grey text-center">

              <th className="p-2">Ticket Id</th>
              <th className="p-2">Title/Issue</th>
              <th className="p-2">Category</th>
              <th className="p-2">Priority</th>
              <th className="p-2">Create Date</th>
              <th className="p-2">Resolve Date</th>
                        <th className="p-2">Engineer</th>
    <th className="p-2">Status</th>
              {/* <th>
                <i className="bx bxs-cog"></i>
              </th> */}
          </thead>

      
              {filteredTickets.map((tkt, index) => (
                <tr key={index} style={{cursor: 'pointer'}} className="text-center" onClick={() => handleShowDetail(tkt)}>
                  <th className='p-2'>{props.clientDetails == null ? `${tkt.assigned_company_id}-` : `${props.clientDetails.company_id}-`}{tkt.ticket_inv}</th>
                  <th className="p-2">  <div className="line-clamp-2">{tkt.title}</div>
</th>
                  <th className="p-2">{tkt.category}</th>
<th
className="p-2"
> <span    style={{
                      // flex: "0.4",
                      backgroundColor: tkt.status != 'Closed' ?
                        tkt.urgency == "1"
                          ? "#FF4C4C"
                          : tkt.urgency == "2"
                            ? "#FFD700"
                            : "#4CAF50"
                            : 'white',
                      color: tkt.status != 'Closed' ? "#fff" : 'black',
                      borderRadius: "4px"
                    }}>
  {tkt.urgency == "1"
    ? "Priority 1"
    : tkt.urgency == "2"
    ? "Priority 2"
    : "Priority 3"}
    </span>
</th>                  <th className="p-2">{removeSeconds(tkt.create_date)}</th>
                  <th className="p-2">{tkt.solve_date ? removeSeconds(tkt.solve_date) : "Pending"}</th>
               <th className='p-2'>{tkt.assigned_tech_name ?? '-'}</th>   
                  <th className='p-2'>{tkt.status}</th>
                  {/* <th>
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </th> */}
                </tr>
              ))}
          </table>
      

      </div>



      {showTicket && (
                <div className="ticket-popup">
          <div className="popup-content" style={{ display: 'block', padding: '1.8em' }}>
            <h3>Ticket Details: ID {detailTicket.ticket_inv}</h3>


 <div  className="row">
                 
    <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Ticket Issue:</label>
              <div className="input-icon">
                <i className="bx bxs-layer"></i>
                <input
                  type="text"
             
                  value={detailTicket.title}
              
                  placeholder="Enter Ticket's Title"
                  required
                />
              </div>
            </div>


    <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Category</label>
              <div className="input-icon">
                <i className="bx bx-category"></i>
                <input
                  type="text"
                
                  value={detailTicket.category}
              
                    placeholder="Ticket category"
                  required
                />
              </div>
            </div>

                <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Sub Category</label>
              <div className="input-icon">
                <i className="bx-list-ul"></i>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={detailTicket.sub_category}
              
                    placeholder="Ticket sub-category"
                  required
                />
              </div>
            </div>


             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Device Type</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.product_sub_cat || product.sub_category}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

             
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Asset ID</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.product_asset_no || product.barcode}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

             
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Product Serial No</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.product_sr_no || product.serial_no}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>
             <div className="form-data col-md-4 col-12 ticket-column">
              <label htmlFor="title">Priority</label>
              <div className="input-icon">
              <i className="bx bx-error-circle"></i>
                <input
                  type="text"
                  value={detailTicket.urgency}
              
                    placeholder="Priority level"
                  required
                />
              </div>
            </div>

      {props.clientDetails == null &&
      <>
       <div className="form-data col-md-4 col-12 ticket-column">
            <label>Company</label>
<div className="input-icon">
  <i className="bx bx-buildings"></i>
  <input
    type="text"
    value={detailTicket.assigned_company_name}
    placeholder="Company name"
    readOnly
  />
</div>
            </div>

             <div className="form-data col-md-4 col-12 ticket-column">
             <label>Raised By</label>
<div className="input-icon">
  <i className="bx bx-user"></i>
  <input
    type="text"
    value={detailTicket.assigned_by_name}
    placeholder="Ticket creator"
    readOnly
  />
</div>
            </div>
             <div className="form-data col-md-4 col-12 ticket-column">
             <label>Role</label>
<div className="input-icon">
  <i className="bx bx-id-card"></i>
  <input
    type="text"
    value={detailTicket.assigned_by_role}
    placeholder="User role"
    readOnly
  />
</div>
            </div>
      </>
}

            
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Created On</label>
<div className="input-icon">
  <i className="bx bx-calendar"></i>
  <input
    type="text"
    value={removeSeconds(detailTicket.create_date)}
    placeholder="Ticket creation date"
    readOnly
  />
</div>
            </div>

            
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Prefered Contact Time</label>
<div className="input-icon">
  <i className="bx bx-clock"></i>
  <input
    type="text"
    value={detailTicket.contact_time}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

            
             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Prevoius Ticket Reference</label>
<div className="input-icon">
<i class="bx bx-ticket" />
  <input
    type="text"
    value={detailTicket.ticket_reference}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

                         <div className="form-data col-md-4 col-12 ">
  <label>Raised Attachment</label>

  <div className="input-icon">
    <i className="bx bx-link"></i>

    {detailTicket.attachments ? (
      <a
        href={`https://api.dectwinservices.com/uploads/${detailTicket.attachments}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007bff", textDecoration: "underline", height:'45px',paddingTop:'8px' }}
      >
        Open Attachment
      </a>
    ) : (
      <span   style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
    )}
  </div>
</div>

<div></div>
            
             <div className="form-data col-12 ticket-column">
            <label>Description</label>
<div className="input-icon">
  <i className="bx bx-detail"></i>
  <textarea
    type="text"
    value={detailTicket.description}
    placeholder="Issue description"
    readOnly
  />
</div>
            </div>




             

             <div className="form-data col-md-4 col-12 ticket-column">
            <label>Resolved On</label>
<div className="input-icon">
  <i className="bx bx-check-circle"></i>
  <input
    type="text"
    value={detailTicket.solve_date ? removeSeconds(detailTicket.solve_date) : "Pending"}
    placeholder="Resolution date"
    readOnly
  />
</div>
            </div>




             <div className="form-data col-md-4 col-12 ticket-column">
              <label>Status</label>
<div className="input-icon">
  <i className="bx bx-loader-circle"></i>
  <input
    type="text"
    value={detailTicket.status}
    placeholder="Current status"
    readOnly
  />
</div>
            </div>

 {detailTicket.assigned_tech_name != null && (
  <>
             <div className="form-data col-md-4 col-12 ticket-column">
             <label>Engineer</label>
<div className="input-icon">
  <i className="bx bx-user-check"></i>
  <input
    type="text"
    value={detailTicket.assigned_tech_name}
    placeholder="Assigned technician"
    readOnly
  />
</div>
            </div>

               <div className="form-data col-md-4 col-12 ticket-column">
             <label>Engineer Remark</label>
<div className="input-icon">
  <i className="bx bx-user-check"></i>
  <input
    type="text"
    value={detailTicket.resolve_notes}
    placeholder="Assigned technician"
    readOnly
  />
</div>
            </div>

                  <div className="form-data col-md-4 col-12 ticket-column">
  <label>Eng Attachment</label>

  <div className="input-icon">
    <i className="bx bx-link"></i>

    {detailTicket.solve_attachments ? (
      <a
        href={`https://api.dectwinservices.com/uploads/${detailTicket.solve_attachments}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007bff", textDecoration: "underline" ,height:'45px',paddingTop:'8px' }}
      >
        Open Attachment
      </a>
    ) : (
      <span style={{  height:'45px',paddingTop:'8px' }}>No attachment</span>
    )}
  </div>
</div>
            

  </>
  
 )}
             
            
  
            </div>

<br />

            <button className="add-btn" onClick={() => setShowTicket(false)}>Close</button>

</div>
</div>
      )}


    </section>
  );
}

export default AdminReports;
